document.addEventListener("DOMContentLoaded", function (e) {
  const paperMatchItems = Array.from(
    document.querySelectorAll(".paper-match__item")
  );
  const productTeasers = Array.from(
    document.querySelectorAll(".paper-match__modal-grid-item")
  );
  const paperMatchModal = document.getElementById("paper-match__modal");
  const closeModal = document.getElementById("closeModal");
  const bannerButtons = Array.from(
    document.querySelectorAll("button.paper-match__category")
  );
  const bannerSlides = Array.from(
    document.querySelectorAll(".paper-match__banner-item")
  );

  const activeBannerItem = document.querySelector(
    ".paper-match__category.active"
  );
  let activeCategory;

  if (!activeBannerItem) {
    activeCategory = bannerButtons[0].dataset.category;
  } else {
    activeCategory = activeBannerItem.dataset.category;
  }

  function filterProductTeasers(id) {
    productTeasers.forEach((teaser) => {
      const paperMatchIds = teaser.dataset.paperMatchIds.split(",");
      if (paperMatchIds.includes(id)) {
        teaser.style.display = "list-item";
      } else {
        teaser.style.display = "none";
      }
    });
  }

  function filterPaperMatchItemsByCategory(category) {
    paperMatchItems.forEach((item) => {
      const categories = item.dataset.categories;
      if (categories.indexOf(category) > -1) {
        item.parentElement.classList.add("show");
      } else {
        item.parentElement.classList.remove("show");
      }
    });
  }

  function setActiveBannerButtons(category) {
    bannerButtons.forEach((bannerButton) => {
      if (bannerButton.dataset.category.trim() === category) {
        bannerButton.classList.add("active");
      } else {
        bannerButton.classList.remove("active");
      }
    });
  }

  function setActiveSlide(index) {
    bannerSlides.forEach((bannerSlide) => {
      if (bannerSlide.dataset.index === index) {
        bannerSlide.classList.add("active");
      } else {
        bannerSlide.classList.remove("active");
      }
    });
  }

  paperMatchItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!e.currentTarget.classList.contains("active")) {
        e.currentTarget.classList.add("active");
        const id = e.currentTarget.dataset.id;
        filterProductTeasers(id);
        paperMatchModal.classList.add("show");
        paperMatchModal.setAttribute("aria-hidden", false);
      }
    });
  });

  closeModal.addEventListener("click", (e) => {
    paperMatchModal.classList.remove("show");
    const activeItem = document.querySelector(".paper-match__item.active");
    if (activeItem) {
      activeItem.classList.remove("active");
    }
    paperMatchModal.setAttribute("aria-hidden", true);
  });

  bannerButtons.forEach((bannerButton) => {
    bannerButton.addEventListener("click", (e) => {
      const index = e.currentTarget.dataset.index;
      const category = e.currentTarget.dataset.category;
      setActiveBannerButtons(category);
      setActiveSlide(index);
      filterPaperMatchItemsByCategory(category);
    });
  });

  filterPaperMatchItemsByCategory(activeCategory);
});
